// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import '../../../css/common.css';
import '../../../css/initialConfigStyle.css';

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js")

// Advisory - Energy Billing
const EnergyBilling = (params) => {
  
  useEffect(() => {    
    
    document.title = "HELIAS - Asesoramiento: Contrato de luz"     
    document.querySelector('meta[name="description"]').setAttribute("content", "Consideraciones a tener en cuenta para reducir tu factura de luz.");

    console.log("Abro asesoramiento para el contrato de luz.")    

  });

  function obtenerPotenciaMaximaContratada(){

    var configPotencia = params.objDatosDashboard.InstallationData.GeneralInfo.PowerConfiguration.split("#")
    var potenciaMaxima = 0
    var potenciaTemp = 0

    for(var x=0; x<configPotencia.length; x++){

      potenciaTemp = configPotencia[x].split("|")[0]

      if(potenciaTemp > potenciaMaxima){
        potenciaMaxima = potenciaTemp
      }

    }

    return potenciaMaxima

  }

  function obtenerConsumoMaximoHistorico(){

    var consumoMaximoHistorico = params.objDatosDashboard.SelfConsumptionAndSavingsData.HistoricalMaxPowerConsumption.Value.replace(".","")

    consumoMaximoHistorico = parseFloat(parseFloat(consumoMaximoHistorico)/1000).toFixed(2)

    return consumoMaximoHistorico

  }

  function obtenerPagoDeMasFacturaPorSubidaPotencia(nuevaPotencia){

    var pagoDeMasFactura = 0
    var configuracionPotencia = params.objDatosDashboard.InstallationData.GeneralInfo.PowerConfiguration.split("#")
    var costeActualPotencia = 0

    for(var x=0; x < configuracionPotencia.length; x++){
      try{
        costeActualPotencia = costeActualPotencia + (parseFloat(configuracionPotencia[x].split("|")[0]) * 30 * parseFloat(configuracionPotencia[x].split("|")[1]))
      }
      catch(error){
        console.log(error)
      }
    }

    for(var y=0; y < configuracionPotencia.length; y++){
      try{
        pagoDeMasFactura = pagoDeMasFactura + (nuevaPotencia * 30 * parseFloat(configuracionPotencia[y].split("|")[1]))
      }
      catch(error){
        console.log(error)
      }
    }

    pagoDeMasFactura = parseFloat(pagoDeMasFactura - costeActualPotencia).toFixed(2)

    return new Intl.NumberFormat('en-DE').format(pagoDeMasFactura)

  }

  function obtenerConclusionPotenciaContratada(){

    var potenciaMaximaContratada = obtenerPotenciaMaximaContratada()
    var consumoMaximoHistorico = obtenerConsumoMaximoHistorico()    
    var numeroExcesosPotenciaDesdeRegistro = parseInt(params.objDatosDashboard.SelfConsumptionAndSavingsData.SinceRegistrationPowerExcessesCount)    
    var tsRegistro = parseInt(params.objDatosDashboard.SelfConsumptionAndSavingsData.SinceRegistrationlastUpdate)
    var tsAhora = parseInt(Date.now()/1000)    
    var segundosDesdeRegistro = parseInt(tsAhora - tsRegistro)
    var numeroMesesDesdeRegistro = parseInt((segundosDesdeRegistro/86400)/30)
    var mediaExcesosMensuales = parseInt(numeroExcesosPotenciaDesdeRegistro / numeroMesesDesdeRegistro)    
    var conclusionPotencia = ""

    if(numeroMesesDesdeRegistro < 1){
      conclusionPotencia = " Todavía es pronto para sacar conclusiones, ***me falta monitorizar tu instalación más tiempo***. Cuando lo tenga claro te avisaré para que la subas, la bajes o la dejes como está."
    }
    else{

      conclusionPotencia = " Tu potencia máxima contratada es de "+new Intl.NumberFormat('en-DE').format(potenciaMaximaContratada)+" kW. "

      if(consumoMaximoHistorico > potenciaMaximaContratada){ //Si he tenido excesos
        if(mediaExcesosMensuales >= 1){          
          conclusionPotencia = conclusionPotencia + "El caso es que tu consumo máximo ha sido de "+new Intl.NumberFormat('en-DE').format(consumoMaximoHistorico)+"kW y veo que tienes muchos excesos de potencia, "+mediaExcesosMensuales+" de media al mes, por lo que seguramente te hayan saltado alguna vez los plomos. La solución a esto sería subir la potencia a "+new Intl.NumberFormat('en-DE').format(parseFloat(parseFloat(consumoMaximoHistorico)+0.051).toFixed(1))+" kW, pero te cobrarían unos 46€ por subirla y además pagarías "+obtenerPagoDeMasFacturaPorSubidaPotencia(parseFloat(parseFloat(consumoMaximoHistorico)+0.051))+"€ más al mes en tu factura. Para evitar esto ***te aconsejo que consideres mis avisos cuando tengas algún exceso para apagar lo que no necesites o que configures alguna regla*** para automatizarlo."
        }
        else{
          conclusionPotencia = conclusionPotencia + "Desde que te registraste tu consumo máximo ha sido de "+new Intl.NumberFormat('en-DE').format(consumoMaximoHistorico)+" kW, pero tus excesos de potencia han sido muy puntuales. ***Te recomiendo que sigas con la potencia que tienes actualmente***."
        }
      }
      else{ //No ha tenido excesos, puede bajarla
        if(consumoMaximoHistorico <= 2){
          conclusionPotencia = conclusionPotencia + "Desde que te registraste nunca la has superado, así que puedes bajarla a 2 kW. Recuerda que te cobrarán 10,95€, pero los amortizarás rapidísimo."
        }
        else{
          conclusionPotencia = conclusionPotencia + "Desde que te registraste nunca la has superado, así que ***puedes bajarla a "+new Intl.NumberFormat('en-DE').format(parseFloat(consumoMaximoHistorico).toFixed(1))+" kW***. Aun así te recomiendo que mires en tu última factura y compruebes cuál ha sido el máximo de tu último año, en caso de que difiera de esto ten en cuenta el valor de la factura. Recuerda que te cobrarán 10,95€, pero los amortizarás rapidísimo."
        }
        
      }
    }

    return (
      <>{conclusionPotencia.split("***")[0]}<strong>{conclusionPotencia.split("***")[1]}</strong>{conclusionPotencia.split("***")[2]}</>
    )

  }

  return (      
    <main className="no-background">

      <section id="welcome-01" className="step">
        <div className="content-wrapper">          
          
            <div className="vertical gap-02">
              <p>Comprueba lo siguiente y seguro que tu factura bajará considerablemente:</p>

              <ul className="default-list">                              
                <li className="success">Revisa si tienes derecho al <strong>bono social de electricidad</strong>, seguramente si eres familia numerosa, pensionista, etc... puedas solicitarlo. Podrías llegar a tener un <strong>descuento de hasta el 80%</strong>. Aquí te dejo el enlace donde se explica todo: <a href="https://www.bonosocial.gob.es/#quees" rel="noopener noreferrer" target="_blank" className="link inline-link">Bono social de electricidad</a>.</li>                
                <li className="success"><strong>Cambia todas las luces de la instalación a LED</strong>, el consumo bajará considerablemente y la amortización será rapidísima.</li>                              
                
                { initialConfigCommonJS.existeSesion() ?
                  <>
                    <li className="success"><strong>Contrata la potencia que necesitas y no más</strong>. 
                    {obtenerConclusionPotenciaContratada()}
                    </li>                              

                    <li className="success"><strong>Que la energía que consumas la pagues a un precio mínimo</strong>.</li>                
                    { Object.keys(params.objDatosDashboard.FVData ).length === 0 ?
                      <></>                              
                    :
                      <li className="success"><strong>Que la energía que vuelques a la red te la paguen a un precio justo</strong>.</li>
                    }               
                  </>
                  :
                  <>
                    {/* METER LOS COMENTARIOS ADICIONALES PARA CONSULTAS PÚBLICAS */}
                    <li className="success"><strong>Contrata la potencia que necesitas y no más</strong>. Para saber si tienes demasiada potencia contratada revisa en tu factura el valor de la "potencia máxima demandada en el último año" y ten en cuenta el valor mayor de los tramos que tengas. Por ejemplo si en tu factura pone que tienes 4,5kW contratados para P1 y P2, y los consumos máximos del último año para P1 y P2 han sido 3,4kW y 2,2kw respectivamente podrías bajar tu potencia contratada a 3,5kW. Si la diferencia es considerable entre P1 y P2 podrías incluso contratar potencias diferentes ("Ej: P1 3,5kW y P2 2,5kW). Ten en cuenta que bajar la potencia te costará aproximadamente 10,95€, pero tranquil@ que se amortizará rápido. Y recuerda que si no te aparece esta información en la factura siempre puedes llamar a tu distribuidora para que te la facilite.</li>
                    <li className="success"><strong>Que la energía que consumas la pagues a un precio mínimo</strong>. Para saber si vuestra tarifa de luz es razonable os animaría a usar nuestro <a href="https://www.fevergy.com/12-Facturas" className="link inline-link" target="_blank" rel="noopener noreferrer">servicio 12 facturas</a>.</li>
                    <li className="success"><strong>Que la energía que vuelques a la red te la paguen a un precio justo</strong>. Si además tienes paneles solares, debes fijarte bien en el precio de venta de tu excedente. Te recomendaría que tengas tarifa de mercado libre ya que suelen dar mejor precio de venta. Para tener una referencia puedes consultar <a href="https://selectra.es/autoconsumo/info/tarifas" className="link inline-link" target="_blank" rel="noopener noreferrer">esta web</a>, mirar el "Precio medio de excedentes" para mercado libre y si lo que te pagan ahora es menor consultar otras comercializadoras que te mejoren ese precio.</li>
                  </>
                }

              </ul>

              { initialConfigCommonJS.existeSesion() ?
                  <></>
                :
                  <p>Por último recuerda que una de las ventajas de tener una suscripción en Helias es que toda esta información la revisaré en tiempo real, con datos exactos de tu medidor y cuando detecte qué necesitas te lo notificaré. De esta manera te despreocuparás y tendrás siempre la certeza de que tienes un contrato acorde a tus consumos y que siempre estarás pagando lo menos posible.</p>
              }

            </div>

            <fieldset>            
              <button className="button primary full-width" onClick={() => params.seleccionarOpcionAdvisory("FeesAnalyzer")}>Comprobemos tus tarifas</button>         
            </fieldset> 

        </div>        

      </section>

    </main>
  )
}

export default EnergyBilling